// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ca0e627","455":"88be7c0f"}[chunkId] + ".chunk.js";
};